import PackageIcon from "@redotech/redo-icons/package.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

export const SelectedParcelsNameFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): ArrayStringTableFilter<string> => ({
  type: AdvancedFilterType.ARRAY_TO_STRING,
  data: {
    name: "selectedParcelsName",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "Package name",
  Icon: PackageIcon,
  operators: [
    ArrayStringFilterOperator.NONE_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.ANY_OF,
  ],
  valueFetcher: fetcher,
  dbSearch: true,
  displayName: "Package name",
});
